import { FieldOptionBase } from 'module/api/field/types';
import { optionsTransformer } from 'module/helpers/filter/option-transformer';
import { ClassNameOnlyProps } from 'module/types/common';
import { SingleSelectField } from 'module/types/filter-field/field/filterable-field';
import { Select } from '@rocketlane/ui';
import { FC, ReactNode, RefObject, useCallback } from 'react';
import styled from 'styled-components';
import { Popover } from '../components/components';
import type { SelectInstance } from 'react-select';

type Props = ClassNameOnlyProps & {
  field: SingleSelectField;
  title: ReactNode;
  onChange: (latest: number | null) => void;
  selectRef: RefObject<SelectInstance>;
  isLoading?: boolean;
};

const StyledPopover = styled(Popover)`
  height: 448px;
`;

export const ControlledSingleSelectFieldEditorPopover: FC<
  React.PropsWithChildren<Props>
> = ({ field, title, onChange, selectRef, className, isLoading }) => {
  const onValueChange = useCallback(
    (latest: FieldOptionBase | null) =>
      onChange(field.value === latest?.value ? null : (latest?.value ?? null)),
    [onChange, field],
  );

  const {
    options: { activeOptions, allOptions },
  } = optionsTransformer(field);

  return (
    <StyledPopover className={className}>
      <Popover.Title>{title}</Popover.Title>
      <Select<FieldOptionBase>
        closeMenuOnSelect
        components={{ LoadingIndicator: null }}
        hideSelectedOptions={false}
        isLoading={isLoading}
        menuFlush
        menuIsOpen
        menuPortalTarget={null}
        ref={selectRef}
        options={activeOptions}
        value={
          field?.value == null
            ? null
            : allOptions.find((x) => x.value === field?.value)
        }
        onChange={onValueChange}
        searchControl
        variant="basic"
        virtualized
      />
    </StyledPopover>
  );
};
